import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import heymathlogo from '../../images/heymathlogo.png';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';

var fpServerResponses = {
      200: 'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',
      403: 'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',
      600: 'Invalid User ID or Email.', // also for 400, 401
      0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'
    };

class ResetPasswordForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {	
				loader:true,
				validToken:false,
				pwdUpdated:false,
				password: '', 
				confirmpassword:'',
				submitButtonDisabled: false,				
				serverMessage: ""
		};
		
		this.handlePwdChange = this.handlePwdChange.bind(this);
		this.handleConfirmPwdChange = this.handleConfirmPwdChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	
		
		this.myTrackerInstance = this.getTracker();
	}

	componentDidMount(){
		//console.log("token=="+this.props.match.params.id);
		
		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				me.setState({validToken:response.isValid,loader:false})
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
		}

		new HmAjax(this.getUrlFor("PWD_TOKEN_VALIDATE")+this.props.match.params.id).get(callBackSuccess,callBackFailure);
	} 
	
	handlePwdChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}
	handleConfirmPwdChange(e) {
		this.handlePwdChange(e);
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid(), serverMessage: "" });
		
		if (this.form.isValid()) {  
			var formData = {					
					"password":this.state.password
			}
			//do cofirm
			var me =this;
			me.setState({submitButtonDisabled: true});
			var callBackSuccess = function(response){				
				console.log("response : ", response);				
				if(response !== null){
					me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false})
				}
			}

			var callBackFailure = function(response){
				me.setState({submitButtonDisabled: false});
			}

			new HmAjax(this.getUrlFor("PWD_RECOVER")+this.props.match.params.id,formData).put(callBackSuccess,callBackFailure);
		}
	}
	
	renderResetPwdform(){
		
		if(this.state.loader === true){			
			return (<div> {this.showLoader()}</div>);
		}
		else if(this.state.validToken === false){
			return(					
						<div className="row">
							<div className="col-md-8 col-md-offset-2 mx-auto nopadding">
								<div className="card rounded-1">
									<div className="card-body text-center">
										<div><img src={heymathlogo} className="heymathlogo"/></div>
										<div className="text-center loginHeaderTxt josefinsansFont mt-50">{this.rb("rpwd.title")}</div>										
										<div>
											<br/>
											<div>{this.rb("rpwd.msg.invalid")}</div>
											<br/>						
											<div>{this.rb("rpwd.msg.tryagain")}</div>
											<br/>
											<br/>
										</div>										
									</div>
								</div>
							</div>
						</div>
			);
		}
		else if(this.state.pwdUpdated === true){
			return(					
						<div className="row">
							<div className="col-md-8 col-md-offset-2 mx-auto nopadding">
								<div className="card rounded-1">
									<div className="card-body text-center">
										<div><img src={heymathlogo} className="heymathlogo"/></div>
										<div className="text-center loginHeaderTxt josefinsansFont mt-50">{this.rb("rpwd.title")}</div>										
										<div>
											<br/>
											<div>{ReactHtmlParser(this.rb("rpwd.msg.success"))}</div>											
											<br/>
											<br/>
										</div>										
									</div>
								</div>
							</div>
						</div>
			);
		}else{
			return (
			<div className="row">
				<div className="col-md-12">
		
					<div className="row">
						<div className="col-md-6 col-md-offset-3 mx-auto nopadding">
							<div className="card rounded-1">
								<div className="card-body text-center">
									<div><img src={heymathlogo} className="heymathlogo"/></div>
									<div className="text-center loginHeaderTxt josefinsansFont mt-50">{this.rb("rpwd.title")}</div>
								
									<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
									onSubmit={this.handleSubmit} noValidate>
									
										<FormGroup for="password">
											<FormControlInput type="password" className="password" name="password" placeholder={this.rb("rpwd.newpwd")}
												innerRef={password => this.password = password}
											value={this.state.password} onChange={this.handlePwdChange}				
											required minLength={1} tabIndex="1"/>
											
											<FieldFeedbacks for="password" show="all">
												<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>				
											</FieldFeedbacks>					
										</FormGroup>
										
										<FormGroup for="confirmpassword">
											<FormControlInput type="password" className="confirmpassword" name="confirmpassword" placeholder={this.rb("rpwd.confirmpwd")}
												innerRef={confirmpassword => this.confirmpassword = confirmpassword}
											value={this.state.confirmpassword} onChange={this.handleConfirmPwdChange}				
											required minLength={1} tabIndex="1"/>
											
											<FieldFeedbacks for="confirmpassword">
												<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>		
												<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
											</FieldFeedbacks>					
										</FormGroup>
											
										
										<div className="forgotpwdMsg">
											<div className="server-messages"> {ReactHtmlParser(this.state.serverMessage)}</div>	
										</div>
										
										<button disabled={this.state.submitButtonDisabled} className="submitButton savebutton">{this.rb("rpwd.save")}</button>
										<br />
									
									</FormWithConstraints>	
								</div>
							</div>
						</div>
					</div>				
				</div>
			</div>
			);
		}
	}
	render() {
		return (
				<div id="loginRoot">				
					<div className="container">
						{this.renderResetPwdform()}
					</div>
				</div>
		);
	}
}

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/views/login/ResetPasswordForm.js